
<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'


export default defineComponent({
  name: "List",
  props: ["list"],
  setup(props) {
    
    const { list } = props

    const { items, style } = list
    const { numPerCol, designWidth, displayTitle } = style
    
    const numCols = computed(() => {
      return Math.ceil(items.length / numPerCol)
    })

    const store = useStore()

    const inMobile = computed(() => {
      return store.state.inMobile
    })

    const listStyle = computed(() => {
      if(inMobile.value) {
        return {
          width:"100%"
        }
      } else {
        return {
          width: `calc(${designWidth} - 10px`
        }
      }
    })

    //which: column number, 0-indexed
    const column = (which) => {
      const len = items.length
      const start = numPerCol*which //inclusive
      const end = start + numPerCol //exclusive
      return items.slice(start, end)
    }

    const width = computed(() => {
      const width = Math.floor(100/numCols.value)+"%"
      return width
    })

    return { column, numCols, width, numCols, items, designWidth, displayTitle, numPerCol, listStyle }
    
  },
});
</script>


<style scoped>
.white-heart {
  left:auto;
  width:30px;
  right:10px; 
  top:10px;
}
/* Causes this weird "shapeFlag" error. No idea why. */
/* .list-container.width {
  width: v-bind(width);
} */
</style>

<template>

  <div class="info-box sb sb-v sb-explicit" :style="listStyle" v-if="items.length > 0 && items.length > numPerCol">
    <h3 class="sb sb-text">{{displayTitle}}</h3>
    <div class="sb-abox white-heart">
      <img src="@images/STHS-WeCare-logo_white-heart.png" alt="WeCare logo" style="object-fit:contain; width:100%; height:auto;"/>
    </div>
    <div class="sb sb-h" style="margin-top:10px;">
      <ul class="list-container sb sb-v sp-explicit sb-gr sb-g10 width" :style="`padding:0px; ${width}`" v-for="i in numCols">
        <li class="sb" :key="i" v-for="item in column(i-1)">{{item}}</li>
      </ul>
    </div>
  </div>
  <div v-else-if="items.length > 0" class="info-box sb sb-v sb-explicit" :style="listStyle">
    <h3 class="sb sb-text">{{displayTitle}}</h3>
    <div class="sb-abox white-heart">
      <img src="@images/STHS-WeCare-logo_white-heart.png" alt="WeCare logo" style="object-fit:contain; width:100%; height:auto;"/>
    </div>
    <ul class="sb sb-v sb-gr sb-g10" style="margin-top:10px; padding:0px;">
      <li class="sb" v-for="item in column(0)">{{item}}</li>
    </ul>
  </div>
</template>

